import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  { path: '/', name: 'home', component: HomeView },
  { path: '/about', name: 'about', component: () => import('../views/AboutView.vue') },

  {
    path: '/portfolio/:filter?',
    name: 'portfolio',
    component: () => import('../views/PortfolioView.vue')
  },

  { path: '/team', name: 'team', component: () => import('../views/TeamView.vue') },
  { path: '/contact', name: 'contact', component: () => import('../views/ContactView.vue') },
  { path: '/:catchAll(.*)*', name: 'notfound', component: () => import('../views/NotFoundView.vue') }
]

export default createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})
